import { Scenario, ScenarioType, Steps } from '../state/interfaces'
import { postalCode, sliderDataInternetSpeed } from './internet-steps'

export const internetSpeedScenarioA: Scenario = {
  id: 'internet-speed-a',
  initialStep: Steps.SLIDER_DATA_AMOUNT,
  type: ScenarioType.INTERNET_SPEED,
  milestones: [sliderDataInternetSpeed.id, postalCode.id],
  version: '1',
  steps: [sliderDataInternetSpeed, postalCode],
  weight: 1,
}
